import { removeArrayElement, removeObjectKey } from '../util/state'

import {
  FETCH_CREATE_SCENE,
  FETCH_CREATE_SCENE_SUCCESS,
  FETCH_CREATE_SLATE,
  FETCH_CREATE_SLATE_SUCCESS,
  FETCH_CREATE_TAKE,
  FETCH_CREATE_TAKE_SUCCESS,
  FETCH_DELETE_SCENE,
  FETCH_DELETE_SCENE_SUCCESS,
  FETCH_DELETE_SLATE,
  FETCH_DELETE_SLATE_SUCCESS,
  FETCH_DELETE_TAKE,
  FETCH_DELETE_TAKE_SUCCESS,
  FETCH_SAVE_SCENE,
  FETCH_SAVE_SCENE_SUCCESS,
  FETCH_SAVE_SLATE,
  FETCH_SAVE_SLATE_SUCCESS,
  FETCH_SAVE_TAKE,
  FETCH_SAVE_TAKE_SUCCESS,
  FETCH_SCRIPT,
  FETCH_SCRIPT_SUCCESS,
  UPDATE_SCENE,
  UPDATE_SLATE,
  UPDATE_TAKE
} from '../constants/ActionTypes'

export default (state = {
  scenes: {
    byId: {},
    allIds: [],
    newLoading: false,
    unsavedChanges: false,
    saveLoading: false,
    deleteLoading: false
  },
  slates: {
    byId: {},
    newLoading: false,
    unsavedChanges: false,
    saveLoading: false,
    deleteLoading: false
  },
  takes: {
    byId: {},
    newLoading: false,
    unsavedChanges: false,
    saveLoading: false,
    deleteLoading: false
  },
  loading: false,
  ready: false
}, {type, payload}) => {
  switch (type) {
    case FETCH_SCRIPT:
      return {
        ...state,
        loading: true
      }

    case FETCH_SCRIPT_SUCCESS:
      return {
        ...state,
        scenes: {
          byId: payload.scenes,
          allIds: Object.keys(payload.scenes)
        },
        slates: {
          byId: payload.slates
        },
        takes: {
          byId: payload.takes
        },
        loading: false,
        ready: true
      }

    case FETCH_CREATE_SCENE:
      return {
        ...state,
        scenes: {
          ...state.scenes,
          newLoading: true
        }
      }

    case FETCH_CREATE_SCENE_SUCCESS:
      return {
        ...state,
        scenes: {
          ...state.scenes,
          byId: {
            ...state.scenes.byId,
            [payload.entry.id]: payload.entry
          },
          allIds: [
            ...state.scenes.allIds,
            payload.entry.id
          ],
          newLoading: false
        }
      }

    case FETCH_CREATE_SLATE:
      return {
        ...state,
        slates: {
          ...state.slates,
          newLoading: true
        }
      }

    case FETCH_CREATE_SLATE_SUCCESS:
      return {
        ...state,
        scenes: {
          ...state.scenes,
          byId: {
            ...state.scenes.byId,
            [payload.sceneId]: {
              ...state.scenes.byId[payload.sceneId],
              slates: [
                ...state.scenes.byId[payload.sceneId].slates,
                payload.entry.id
              ]
            }
          }
        },
        slates: {
          ...state.slates,
          byId: {
            ...state.slates.byId,
            [payload.entry.id]: payload.entry
          },
          newLoading: false
        }
      }

    case FETCH_CREATE_TAKE:
      return {
        ...state,
        slates: {
          ...state.slates,
          newLoading: true
        }
      }

    case FETCH_CREATE_TAKE_SUCCESS:
      return {
        ...state,
        slates: {
          ...state.slates,
          byId: {
            ...state.slates.byId,
            [payload.slateId]: {
              ...state.slates.byId[payload.slateId],
              takes: [
                ...state.slates.byId[payload.slateId].takes,
                payload.entry.id
              ]
            }
          }
        },
        takes: {
          ...state.takes,
          byId: {
            ...state.takes.byId,
            [payload.entry.id]: payload.entry
          },
          newLoading: false
        }
      }

    case UPDATE_SCENE:
      return {
        ...state,
        scenes: {
          ...state.scenes,
          byId: {
            ...state.scenes.byId,
            [payload.id]: {
              ...state.scenes.byId[payload.id],
              [payload.fieldName]: payload.fieldValue
            }
          },
          unsavedChanges: true
        }
      }

    case UPDATE_SLATE:
      return {
        ...state,
        slates: {
          ...state.slates,
          byId: {
            ...state.slates.byId,
            [payload.id]: {
              ...state.slates.byId[payload.id],
              [payload.fieldName]: payload.fieldValue
            }
          },
          unsavedChanges: true
        }
      }

    case UPDATE_TAKE:
      return {
        ...state,
        takes: {
          ...state.takes,
          byId: {
            ...state.takes.byId,
            [payload.id]: {
              ...state.takes.byId[payload.id],
              [payload.fieldName]: payload.fieldValue
            }
          },
          unsavedChanges: true
        }
      }

    case FETCH_SAVE_SCENE:
      return {
        ...state,
        scenes: {
          ...state.scenes,
          saveLoading: true
        }
      }

    case FETCH_SAVE_SCENE_SUCCESS:
      return {
        ...state,
        scenes: {
          ...state.scenes,
          saveLoading: false,
          unsavedChanges: false
        }
      }

    case FETCH_SAVE_SLATE:
      return {
        ...state,
        slates: {
          ...state.slates,
          saveLoading: true
        }
      }

    case FETCH_SAVE_SLATE_SUCCESS:
      return {
        ...state,
        slates: {
          ...state.slates,
          saveLoading: false,
          unsavedChanges: false
        }
      }

    case FETCH_SAVE_TAKE:
      return {
        ...state,
        takes: {
          ...state.takes,
          saveLoading: true
        }
      }

    case FETCH_SAVE_TAKE_SUCCESS:
      return {
        ...state,
        takes: {
          ...state.takes,
          saveLoading: false,
          unsavedChanges: false
        }
      }

    case FETCH_DELETE_SCENE:
      return {
        ...state,
        scenes: {
          ...state.scenes,
          deleteLoading: true
        }
      }

    case FETCH_DELETE_SCENE_SUCCESS:
      return {
        ...state,
        scenes: {
          ...state.scenes,
          byId: removeObjectKey(state.scenes.byId, payload.id),
          allIds: removeArrayElement(state.scenes.allIds, payload.id),
          deleteLoading: false
        }
      }

    case FETCH_DELETE_SLATE:
      return {
        ...state,
        slates: {
          ...state.slates,
          deleteLoading: true
        }
      }

    case FETCH_DELETE_SLATE_SUCCESS:
      return {
        ...state,
        scenes: {
          ...state.scenes,
          byId: {
            ...state.scenes.byId,
            [payload.sceneId]: {
              ...state.scenes.byId[payload.sceneId],
              slates: removeArrayElement(state.scenes.byId[payload.sceneId].slates, payload.id)
            }
          }
        },
        slates: {
          ...state.slates,
          byId: removeObjectKey(state.slates.byId, payload.id),
          deleteLoading: false
        }
      }

    case FETCH_DELETE_TAKE:
      return {
        ...state,
        takes: {
          ...state.takes,
          deleteLoading: true
        }
      }

    case FETCH_DELETE_TAKE_SUCCESS:
      return {
        ...state,
        slates: {
          ...state.slates,
          byId: {
            ...state.slates.byId,
            [payload.slateId]: {
              ...state.slates.byId[payload.slateId],
              takes: removeArrayElement(state.slates.byId[payload.slateId].takes, payload.id)
            }
          }
        },
        takes: {
          ...state.takes,
          byId: removeObjectKey(state.takes.byId, payload.id),
          deleteLoading: false
        }
      }

    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./reducers/Script.js